export default __webpack_public_path__ + "static/media/amiens7.69e44a9b.jpg";